<app-layout title="Recepción de Informes">
  <div class="row mt-5 px-2 px-md-5">
    <div class="col-12 col-md-4 mb-3">
      <button class="btn btn-sm btn-primary w-100" (click)="routeTo('periods')">
        <i class="fas fa-calendar-alt"></i> Configurar Periodos
      </button>
    </div>
    <div class="col-12 col-md-4 mb-3">
      <button class="btn btn-sm btn-primary w-100" (click)="routeTo('concepts')">
        <i class="fas fa-list"></i> Configurar Conceptos
      </button>
    </div>
    <div class="col-12 col-md-4 mb-3">
      <button class="btn btn-sm btn-primary w-100" (click)="routeTo('user/admin-users')">
        <i class="fas fa-users"></i> Configurar Usuarios
      </button>
    </div>
  </div>
</app-layout>